import Header from './../../Headers/HeaderForAreLoggedIn/index.vue'
import Footer from './../../Footers/Footer/index.vue'
import ProgressHUD from './../../ProgressHUD/index.vue'
import { Api, Toast, VerificationPermits } from './../../../services'

export default {
  name: 'project',
  props: [],
  components: {
    Header,
    Footer,
    ProgressHUD,
  },
  mounted() {},
  data() {
    return {
      basketItems: null,
      paymentMethod: {
        bitcoin: false,
        ether: false,
        solarCoin: false,
        card: false,
        green: false,
        paypal: false,
      },
      walletAddress: '',
      walletAddress2: '',
      cardAddress: {
        number: '',
        date: '',
        cvv: '',
      },
      notSelectedPaymentMethods: false,
      shippingAddress: {
        name: '',
        company: '',
        address: '',
        country: '',
        city: '',
        state: '',
        zip: '',
      },
      shippingAndBillingAddressIsSame: false,
      billingAddress: {
        address: '',
        company: '',
        state: '',
        country: '',
      },
      shippingMethod: '',
      orderDatails: null,
      statusMessage: '',
      now: Math.trunc(new Date().getTime() / 1000),
      date: null,
      qrData: '',
      confirmingDeposit: false,
      cancelDeposit: false,
      profileData: null,
      metamask: false,
      payMethods: {"btc": false, "eth": false, "cc": false, "pp": false},
    }
  },
  methods: {
    async ppCheckout() {

      this.$refs.progress.show()

      var order = {
        walletAddress: this.walletAddress,
        cardAddress: this.cardAddress,
        coin: "",
        products: this.basketItems.map(function(item) {
          return { productId: item.product._id, quantity: item.quantity }
        }),
        count: this.basketItems.length,
        shippingAddress: this.shippingAddress,
        billingAddess: this.shippingAndBillingAddressIsSame
          ? this.shippingAddress
          : this.billingAddress,
        shippingMethod: this.shippingMethod,
      }

      console.log("order>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
      console.log(order)

      var response = await Api.addPPOrder(order)

      // this.$http.post('/buy', order)
      // .then(
      //    response => {
      //     console.log("response buy")
      console.log('response>>>>>>>>>>>>>>>>>>>')
      console.log(response)
      console.log(response.data.result)
      this.orderDatails = response
      window.location.href = response.data.result
      // },
      // error => {
      //   console.log("NO SAVE TRANSACTION")
      //   console.log(error)
      // });
    },

    getBasketItems() {
      return this.$store.getters.getBasketItems
    },
    removeItem(item) {
      this.$store.commit('removeItem', item)
    },
    changeQuantity(item) {
      item.quantity = Math.max(
        Math.min(Math.round(item.quantity), item.product.available),
        1
      )
      this.$store.commit('changeQuantity', { productItem: item })
    },
    selectPaymentMethod(bitcoin, ether, solarCoin, card, green, paypal) {
      this.paymentMethod.bitcoin = bitcoin
      this.paymentMethod.ether = ether
      this.paymentMethod.solarCoin = solarCoin
      this.paymentMethod.card = card
      this.paymentMethod.green = green
      this.paymentMethod.paypal = paypal

      this.walletAddress = window.wAddress
      if (!this.paymentMethod.green)
        this.walletAddress = ''

      this.checkIsSelectedPaymentMethods()
    },
    checkIsSelectedPaymentMethods() {
      this.notSelectedPaymentMethods =
        this.paymentMethod.bitcoin == false &&
        this.paymentMethod.ether == false &&
        this.paymentMethod.solarCoin == false &&
        this.paymentMethod.card == false &&
        // this.paymentMethod.green == false &&
        this.paymentMethod.paypal == false

      return !this.notSelectedPaymentMethods
    },

    async completeCheckout() {
      if (this.paymentMethod.green && !this.metamask) {
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Please unlock Metamask and update this page',          
        })

        return
      }

      if (this.basketItems.length == 0) {
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'You did not add items to the cart.',
        })

        return
      }

      if (
        this.requestBuyServiceProduct() == true &&
        this.approveBuyServiceProduct() == false
      ) {
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message:
            'Your request has not been processed yet. It will take some time.',
        })

        return
      }

      if (
        this.requestBuyServiceProduct() == false &&
        this.approveBuyServiceProduct() == false
      ) {
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'To make a payment, you need one of the permissions.',
        })

        return
      }

      if(!this.checkIsSelectedPaymentMethods() && this.paymentMethod.green){
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'To make a payment, you need select method of a payment. You can pay GREENs only 10% of the total amount.',
          showDuration: 2000,
        })
        return
      }

      const isValid = await this.$validator.validateAll()
      if (!isValid || !this.checkIsSelectedPaymentMethods()) {
        Toast.validationFieldsError({ toast: this.$toast })
        return
      }

      var walletGreen = this.walletAddress
      this.walletAddress = (this.walletAddress2 != "") ? this.walletAddress2 : this.walletAddress;

      var order = {
        walletAddress: this.walletAddress,
        cardAddress: this.cardAddress,
        coin: this.getCoin(),
        products: this.basketItems.map(function(item) {
          return { productId: item.product._id, quantity: item.quantity }
        }),
        count: this.basketItems.length,
        shippingAddress: this.shippingAddress,
        billingAddess: this.shippingAndBillingAddressIsSame
          ? this.shippingAddress
          : this.billingAddress,
        shippingMethod: this.shippingMethod,
      }

      if (this.paymentMethod.green) {
        //this.$refs.progress.show()
        // console.log('this.orderDatails >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
        // console.log(order)
        var products = JSON.stringify(order.products)
        var response = await Api.getAmount(products)

        console.log("response***************************")
        console.log(response)       
       
            // this.walletAddress = window.wAddress
            var _s = this,
              recipient = '0x7a55dfbb2000f680d50521c685494f01f0b13d72', //'0x1D20187d2A142BEB5Ee3B0eC983c1082D4022706',
              amount = response.data.amount,
              summary = response.data.summary,
              balance = response.data.balance
          

            web3.eth
              .contract(window.tokenmain.contractABI)
              .at(window.tokenmain.contractAddress)
              .transfer(recipient, amount + '000000000000000000', function(error, result) {
                if (!error) {
                  console.log('result')
                  console.log(result)

                  var now = new Date(),
                    datetrans = ''
                  datetrans = now.toString().substr(4, 11)

                  // _s.drawItem('Send', 'https://ropsten.etherscan.io/tx/' + result, result, datetrans).toStorage();
                  var data = {
                    hash: result,
                    userid: localStorage.getItem('userid'),
                    fromGreen: walletGreen,
                    toAddressGreen: recipient,
                    amountGreen: amount,
                    summary: summary,
                    balance: balance,

                    order: JSON.stringify(order),
                  }

                  _s.$http.post('/api/addgreenorder', data).then(
                    response => {
                      console.log('RESPONSE ADD TRANSACTION DATA')
                      console.log(response)
                      Toast.success({
                        toast: _s.$toast,
                        title: 'Success!',
                        message: 'Successfully paid',
                      })
                      if (!_s.paymentMethod.card) {
                        _s.$refs.progress.show()
                        console.log('payment !!!!!!!caRD')
                        console.log(_s.paymentMethod.card)
                        _s.$http
                          .post('/api/updorder', response.body.order)
                          .then(
                            response => {
                              console.log('RESPONSE updORDER>>>>>>>>>>>>>>>>')
                              console.log(response)
                              _s.orderDatails = {}
                              _s.orderDatails.data = response.body
                              _s.$refs.progress.hide()
                              // Clear all items in basket
                              if (_s.orderDatails) {
                                _s.$store.commit('clearItems')
                              }
                              _s.qrData = _s.orderDatails.data.toAddress
                              // Check checkOrder every 15 minutes
                              setInterval(function() {
                                checkOrder()
                                _s.initTimer()
                              }, 900000)
                              _s.initTimer()
                            },
                            error => {
                              console.log('NO SAVE TRANSACTION')
                              console.log(error)
                            }
                          )
                        } else if (_s.paymentMethod.card) {
                          _s.$refs.progress.show()
                          Api.addStripeOrder(response.body.order).then(() => {
                            Toast.success({
                              toast: _s.$toast,
                              title: 'Success!',
                              message: 'Successfully paid',
                            })
                            _s.$router.push('marketplace')
                            _s.$refs.progress.hide()
                            if (_s.orderDatails) {
                              _s.$store.commit('clearItems')
                            }
                          })
                        } else if (_s.paymentMethod.paypal) {
                          _s.ppCheckout();
                        }
                    },
                    error => {
                      console.log('NO SAVE TRANSACTION')
                      console.log(error)
                    }
                  )
                } else {
                  console.log('error')
                  console.log(error)                 
                  Toast.error({
                    toast: _s.$toast,
                    title: 'Error',
                    message:
                      'Your request has not been processed yet. It will take some time.',
                  })

                  //_s.drawItem('Send', '#send', error.message.split('\n')[0], datetrans)
                }
            })
      
      } else if (!this.paymentMethod.card && !this.paymentMethod.paypal) {
        this.$refs.progress.show()
        this.orderDatails = await Api.addOrder(order)
        this.$refs.progress.hide()

        // Clear all items in basket
        if (this.orderDatails) {
          this.$store.commit('clearItems')
        }

        this.qrData = this.orderDatails.data.toAddress

        // Check checkOrder every 15 minutes
        setInterval(function() {
          checkOrder()
          this.initTimer()
        }, 900000)

        this.initTimer()
      } else if (this.paymentMethod.card) {
        this.$refs.progress.show()
        Api.addStripeOrder(order).then(() => {
          Toast.success({
            toast: this.$toast,
            title: 'Success!',
            message: 'Successfully paid',
          })

          this.$router.push('marketplace')
          this.$refs.progress.hide()
          if (this.orderDatails) {
            this.$store.commit('clearItems')
          }
        })

      } else if (this.paymentMethod.paypal) {
        this.ppCheckout();
      }
    },
    initTimer() {
      this.date = new Date(new Date().getTime() + 900000) / 1000
    },
    async checkOrder() {
      var response = null

      if (this.paymentMethod.bitcoin) {
        response = await Api.checkOrderBTC(this.orderDatails.data.orderId)
      } else if (this.paymentMethod.ether) {
        response = await Api.checkOrderETH(this.orderDatails.data.orderId)
      } else if (this.paymentMethod.solarCoin) {
        response = await Api.checkOrderSLR(this.orderDatails.data.orderId)
      }

      if (response.data == 'no') {
        this.statusMessage =
          'Transaction not yet found. If you paid, try again later.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Transaction not yet found. If you paid, try again later.',
        })

        return
      } else {
        Toast.success({
          toast: this.$toast,
          title: 'Success!',
          message: 'Successfully paid',
        })

        this.confirmingDeposit = true
      }
    },

    drawItem(title, url, subtitle, datetrans) {
      var item = {
        title: title,
        url: url,
        subtitle: subtitle,
        datetrans: datetrans,
      }

      this.txList += this.txItem(item)
      // console.log("template.txItem(item)------2")
      // console.log(this.txItem(item))
      var _s = this

      return {
        toStorage: function() {
          _s.items.push(item)
          localStorage.setItem('items', JSON.stringify(_s.items))
        },
      }
    },
    txItem(params) {
      return `<div class="tile tile-centered" style="">
                <div class="tile-content">
                  <div class="tile-title">${params.datetrans}</div>
                  <a href="${params.url}" class="tile-subtitle">${
        params.subtitle
      }</a>
                </div>
              </div>`
    },
    itemsFromStorage() {
      var _s = this
      this.items = JSON.parse(localStorage.getItem('items')) || []
      // console.log(this.items)
      this.items.forEach(function(item) {
        _s.drawItem(item.title, item.url, item.subtitle, item.datetrans)
      })
    },
    async cancelOrder() {
      var response = Api.cancelOrder(this.orderDatails.data.orderId)
      
      this.cancelDeposit = true
    },
    getCoin() {
      if (this.paymentMethod.bitcoin) return 'BTC'
      else if (this.paymentMethod.ether) return 'ETH'
      else if (this.paymentMethod.green) return 'GNET'
      else return 'SLR'
    },
    approveBuyServiceProduct() {
      return VerificationPermits.approveBuyServiceProduct(
        (this.profileData || {}).permission || null
      )
    },
    requestBuyServiceProduct() {
      return VerificationPermits.requestBuyServiceProduct(
        (this.profileData || {}).permission || null
      )
    },
  },
  computed: {
    getBasketTotal() {
      var total = 0

      for (var item of this.$store.getters.getBasketItems) {
        total += item.product.price * item.quantity
      }

      return total
    },
    timer() {
      let m = Math.trunc((this.date - this.now) / 60) % 60,
        s = Math.trunc(this.date - this.now) % 60
      if (m < 0) m = 0
      if (s < 0) s = 0
      m = m < 10 ? '0' + m : m
      s = s < 10 ? '0' + s : s
      return m + ':' + s
    },
  },
  mounted() {
    this.$nextTick(function() {
      $(document).ready(function() {
        Materialize.updateTextFields()
      })
    })
  },
  async created() {
    this.basketItems = this.getBasketItems()

    if(this.basketItems[0].product.payMethods) {
      var pay = this.basketItems[0].product.payMethods
      for(var i=0; i<pay.length; i++){
        this.payMethods[pay[i]] = true
      }    
    }  

    console.log('route   ????????????????')
    console.log(this.$route.query.token)
    if (
      this.$route.query &&
      this.$route.query.paymentId &&
      this.$route.query.token
    ) {
      var paymentId = this.$route.query.paymentId,
        token = this.$route.query.token,
        PayerID = this.$route.query.PayerID

      var response = await Api.successPayPP(paymentId, token, PayerID)
      console.log('response')
      console.log(response)

      Toast.success({
            toast: this.$toast,
            title: 'Success!',
            message: 'Successfully paid',
          })

          this.$router.push('marketplace')
          this.$refs.progress.hide()
          if (this.orderDatails) {
            this.$store.commit('clearItems')
          }
    } else if (this.$route.query && this.$route.query.token) {
      var token = this.$route.query.token
      var response = await Api.errPayPP(token)
      console.log('response')
      console.log(response)
    }

    setInterval(() => {
      this.now = Math.trunc(new Date().getTime() / 1000)
    }, 1000)

    this.walletAddress = window.wAddress

    if (typeof web3 !== 'undefined') {
      console.log('Metamask exist on the page!')
      var _s = this
      window.web3 = new Web3(web3.currentProvider)
      web3.net.getListening(function(error, result) {
        if (!error && result) {
          if (typeof web3.eth.defaultAccount !== 'undefined') {
            var account = web3.eth.defaultAccount
            _s.walletAddress = account
            window.wAddress = account
            console.log('Metamask exist on the page!!!')
            _s.metamask = true
          } else {
            console.log('Please unlock Metamask and refresh the page!')
          }
        }
      })
    } else {
      console.log('Please unlock Metamask and refresh the page!!!')
    }

    try {
      var response = await Api.myProfileSmallInfo()
      this.profileData = response.data.user
    } catch (error) {
      console.error(error)
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Checkout/Checkout.component.js